import React from 'react'
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  InputGroup,
  InputLeftElement,
  HStack,
  Divider,
  Text,
  useColorModeValue,
  SimpleGrid,
  Select,
} from '@chakra-ui/react'
import { SearchIcon, RepeatIcon, CalendarIcon, PhoneIcon } from '@chakra-ui/icons'
import { FaUser, FaCheckCircle } from 'react-icons/fa'

export const FilterBar = ({ isLoading, onLimpar, register, handleSubmit }) => {
  const bgColor = useColorModeValue('white', 'gray.800')
  const borderColor = useColorModeValue('gray.200', 'gray.700')
  

  return (
    <Box bg={bgColor} p={5} borderRadius="md" shadow="sm" mb={5} borderWidth="1px" borderColor={borderColor}>
      <Text fontWeight="medium" fontSize="md" mb={3}>
        Filtros
      </Text>
      <Divider mb={4} />

      <form onSubmit={handleSubmit}>
        <Stack spacing={4} direction="column">
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
            <FormControl>
              <FormLabel fontSize="sm">Código do Vendedor</FormLabel>
              <InputGroup size="sm">
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="gray.400" />
                </InputLeftElement>
                <Input {...register('cod_vendedor')} placeholder="Código do vendedor (ex: 26)" borderRadius="md" type="number" />
              </InputGroup>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">Nome do Vendedor</FormLabel>
              <InputGroup size="sm">
                <InputLeftElement pointerEvents="none">
                  <FaUser color="gray.400" />
                </InputLeftElement>
                <Input {...register('nome_vendedor')} placeholder="Nome do vendedor (ex: Mirian)" borderRadius="md" />
              </InputGroup>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">Código do Parceiro</FormLabel>
              <InputGroup size="sm">
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="gray.400" />
                </InputLeftElement>
                <Input {...register('cod_parceiro')} placeholder="Código do parceiro (ex: 29683)" borderRadius="md" type="number" />
              </InputGroup>
            </FormControl>
          </SimpleGrid>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
            <FormControl>
              <FormLabel fontSize="sm">Data de Agendamento (De)</FormLabel>
              <InputGroup size="sm">
                <InputLeftElement pointerEvents="none">
                  <CalendarIcon color="gray.400" />
                </InputLeftElement>
                <Input {...register('data_agendamento_inicio')} placeholder="Data inicial" type="date" borderRadius="md" />
              </InputGroup>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">Data de Agendamento (Até)</FormLabel>
              <InputGroup size="sm">
                <InputLeftElement pointerEvents="none">
                  <CalendarIcon color="gray.400" />
                </InputLeftElement>
                <Input {...register('data_agendamento_fim')} placeholder="Data final" type="date" borderRadius="md" />
              </InputGroup>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">Tipo de Agendamento</FormLabel>
              <InputGroup size="sm">
                <InputLeftElement pointerEvents="none">
                  <PhoneIcon color="gray.400" />
                </InputLeftElement>
                <Select {...register('tipo_agendamento')} placeholder="Selecione o tipo" borderRadius="md" pl={10}>
                  <option value="email">Email</option>
                  <option value="whatsapp">WhatsApp</option>
                  <option value="telefone">Telefone</option>
                </Select>
              </InputGroup>
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm">Status</FormLabel>
              <InputGroup size="sm">
                <InputLeftElement pointerEvents="none">
                  <FaCheckCircle color="gray.400" />
                </InputLeftElement>
                <Select {...register('status')} borderRadius="md" pl={10}>
                  <option value="todos">Todos</option>
                  <option value="pendentes">Pendentes</option>
                  <option value="concluidos">Concluídos</option>
                </Select>
              </InputGroup>
            </FormControl>

          </SimpleGrid>

          <HStack spacing={2} alignSelf={{ base: 'flex-end' }} justifyContent="flex-end">
            <Button leftIcon={<RepeatIcon />} variant="outline" onClick={onLimpar} size="sm" isDisabled={isLoading} borderRadius="md" type="button">
              Limpar
            </Button>

            <Button leftIcon={<SearchIcon />} colorScheme="blue" isLoading={isLoading} loadingText="Buscando" size="sm" borderRadius="md" type="submit">
              Buscar
            </Button>
          </HStack>
        </Stack>
      </form>
    </Box>
  )
}
